import { Directive } from "../Directive.js";
import type { Engine } from "../../../../royalur/engine/Engine.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { GameState } from "../../../../royalur/engine/state/GameState.js";


/**
 * A directive for rendering the dice.
 */
export abstract class BoardDirective extends Directive {
    readonly rules: Engine;
    readonly moveIndex: number;

    protected constructor(
        directiveID: number,
        rules: Engine,
        moveIndex: number,
    ) {
        super(directiveID);
        this.rules = rules;
        this.moveIndex = moveIndex;
    }

    abstract getState(): GameState;

    abstract getActivePlayer(): PlayerType;
}
